// extracted by mini-css-extract-plugin
module.exports = {"wumrckq":"wumrckq","dbktvgw":"dbktvgw","d174td66":"d174td66","dot-animation-d174td66":"dot-animation-d174td66"};